export default __webpack_public_path__ + "static/media/listen.4d4048df.svg";